// import NotFoundPageImage from "../../assets/signature/404-not-found.jpg"
import OnProgress from "../../assets/on-dev.png"


export default function NotFoundPage() {

  return (

    <div className="body" >
        <div className="page-header-card">
          <div className="page-header-top d-flex">
            <div className="page-title-wrap">
              <h4 className="page-title-text">Sedang dalam pengembangan 🙏</h4>
            </div>
          </div>
        </div>
      
      <div className="body-content text-center" style={{padding: "35px 0"}}>
        <img src={OnProgress} className="img-fluid" style={{width:"60%"}} />
      </div>

    </div>

  );
}
